import React from 'react';
import { NavLink } from 'react-router-dom';

// Menu link set in the admin (header / mobile menu).
// Store pages use the router so the current page is highlighted; other websites open in a new tab.
// `className` is a function of isActive, like NavLink's.
const MenuLink = ({ link, className, children, onClick }) => {
  if (/^https?:\/\//i.test(link.link)) {
    return (
      <a href={link.link} target="_blank" rel="noopener noreferrer" className={className(false)} onClick={onClick}>
        {children}
      </a>
    );
  }
  const to = link.link || '/';
  return (
    <NavLink to={to} end={to === '/collections' || to === '/'} className={({ isActive }) => className(isActive)} onClick={onClick}>
      {children}
    </NavLink>
  );
};

export default MenuLink;
